export const degreesToRadian = (degrees) => {
  return degrees * (Math.PI / 180);
};
